import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FileService } from '../../../core/service/file.service';
import { Contract } from '../../model/contract';
import { LeaseAgreementDocumentService } from '../../service/data/lease-agreement-document.service';
import { Subscription } from 'rxjs';
import { LeaseAgreementDocument } from '../../model/lease-agreement-document';
import { SelectionItem } from '../../../core/component/select/select.component';
import { ESignatory, InformationChannelKind, SigningRoleKind } from '../../model/esignatory';
import { LocalDate } from '../../../core/model/local-date';
import { MessageService } from '../../../core/service/message.service';
import { UserAccountService } from '../../../common/service/user-account.service';
import { ControlDataFormService } from '../../service/data/control-data-form.service';

@Component({
    selector: 'app-control-data-regenerate-form',
    templateUrl: './control-data-regenerate-form.component.html',
    styleUrls: ['./control-data-regenerate-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControlDataRegenerateFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: ControlDataFormService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  public dataContext: any;
  form: FormGroup;
  _subscription: Subscription = new Subscription();

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.form = this._fb.group({
      ids: this._fcf.createHidden(this.dataContext),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this._subscription.add(
        this._dataService
          .RegenerateControlData(this.dataContext)
          .pipe()
          .subscribe(res => this._actionService.complete(res))
      );
    }
  }
}
